/**
 * 도서산간지역
 * --
 */
const RemoteArea = [
  {
    key: 1,
    city: '제주시',
    range: ['63000', '63349'],
    price: 3000,
  },
  {
    key: 2,
    city: '서귀포시',
    range: ['63500', '63699'],
    price: 3000,
  },
  {
    key: 3,
    city: '울릉군',
    range: ['40200', '40266'],
    price: 5000,
  },
  {
    key: 4,
    city: '진도군',
    range: ['58900', '58959'],
    price: 5000,
  },
  {
    key: 5,
    city: '완도군',
    range: ['59100', '59199'],
    price: 5000,
  },
  {
    key: 6,
    city: '신안군',
    range: ['58800', '58869'],
    price: 5000,
  },
  {
    key: 7,
    city: '여수시 (도서 지역)',
    range: ['59600', '59699'],
    price: 5000,
  },
  {
    key: 8,
    city: '옹진군',
    range: ['22386', '23149'],
    price: 5000,
  },
  {
    key: 9,
    city: '보령시 (도서 지역)',
    range: ['33411', '33499'],
    price: 5000,
  },
  {
    key: 10,
    city: '거제시 (도서 지역)',
    range: ['53300', '53399'],
    price: 5000,
  },
  {
    key: 11,
    city: '군산시 (도서 지역)',
    range: ['54000', '54099'],
    price: 5000,
  },
];

export default RemoteArea;
